<section class="all-users-data">
  <div class="table-responsive admin-dashboard-table">
    <ag-grid-angular style="width: 100%; height: 500px;" class="ag-theme-alpine" [rowData]="rows" [columnDefs]="columns"></ag-grid-angular>
  </div>
</section>
